<script lang="ts">
    import { getColorHexOfStatus } from "../../../Utils/AvailabilityStatus";
    import { getColorByString } from "../../../Utils/ColorGenerator";
    import Woka from "../../Woka/WokaFromUserId.svelte";
    import { availabilityStatusStore } from "../../../Stores/MediaStore";
    import { gameManager } from "../../../Phaser/Game/GameManager";
    import { ENABLE_OPENID } from "../../../Enum/EnvironmentVariable";
    import { userIsConnected } from "../../../Stores/MenuStore";
    import ActionBarButton from "../ActionBarButton.svelte";
    import { analyticsClient } from "../../../Administration/AnalyticsClient";
    import { connectionManager } from "../../../Connection/ConnectionManager";
    import LL from "../../../../i18n/i18n-svelte";
    import IconLogout from "../../Icons/meta/IconLogout.svelte";
    import SettingsMenuItem from "./SettingsMenuItem.svelte";
    import LoginMenuItem from "./LoginMenuItem.svelte";

    const userName = gameManager.getPlayerName() || "";
    const userColor = getColorByString(userName);
</script>

<div data-testid="profile" class="flex justify-end transition-all" aria-label="Профиль">
    <div
        class="flex flex-col bg-mlight/80 shadow-light rounded-md2 backdrop-blur p-3 gap-1 pointer-events-auto
                narrow:bg-transparent narrow:shadow-none narrow:backdrop-blur-none narrow:p-0 narrow:gap-0"
    >
        <div class="relative w-[64px] self-center narrow:hidden">
            <div
                data-testid="profile-avatar"
                class="overflow-hidden flex items-center justify-center aspect-square rounded-full w-[64px] h-[64px]"
                style="background-color: {userColor ?? 'transparent'}"
            >
                <Woka userId={-1} placeholderSrc="" customWidth="64px" />
            </div>
            <div
                class="aspect-square h-2 w-2 rounded-full absolute bottom-0 right-0"
                style="background-color: {getColorHexOfStatus($availabilityStatusStore)}"
            ></div>
        </div>
        <div class="font-medium text-mdark select-none text-sm text-center w-[84px] truncate mb-1 narrow:hidden">
            {userName}
        </div>
        <div class="flex flex-row gap-1 justify-center">
            <SettingsMenuItem />
            {#if !(ENABLE_OPENID && $userIsConnected)}
                <LoginMenuItem classList="group w-fit narrow:hidden" />
            {/if}
            {#if ENABLE_OPENID && $userIsConnected}
                <ActionBarButton
                    state="forbidden"
                    onclick={() => {
                        analyticsClient.trackAdminEvent("auth.logout_clicked");
                        connectionManager.logout();
                    }}
                    title={$LL.menu.profile.logout()}
                    classList="narrow:hidden"
                    dataTestId="logout"
                >
                    <IconLogout />
                </ActionBarButton>
            {/if}
        </div>
    </div>
</div>
